/* eslint-disable */
import React, { PureComponent } from 'react';
import { Route, Switch, Redirect, withRouter } from 'react-router';
import { ConnectedRouter } from 'connected-react-router';
import Loadable from 'react-loadable';
import { connect } from 'react-redux';
import Loader from './components/LayoutComponents/Loader';
import NotFound from './pages/404';
import IndexLayout from './layouts';
import { logPageView } from './analytics';
import { ALL_FACILITY_ROLES } from './services/roles';
// currentAccount (services/auth) is loaded lazily at its lifecycle call site —
// services/auth.js's transitive import of the Parse SDK (~193 KB raw) was the
// second of two synchronous chains pulling Parse into main.js; the first was
// the saga registry (now lazy via configureStore.js bootstrapSaga).

const loadable = (loader) =>
  Loadable({
    loader,
    delay: false,
    loading: () => <Loader />,
  });

// Facility portal: trimmed to three features — Auth, Service Map (dashboard),
// and Reservations. Other fleet-portal routes (reports, fleet, programs,
// account management, bookings/members/etc.) were removed; their shared code
// is kept on disk but is not navigable here.
const routes = [
  // Auth pages
  {
    path: '/auth/login',
    component: loadable(() => import('./pages/auth/login/index')),
    privilege: [],
    exact: true,
  },
  {
    path: '/auth/signup',
    component: loadable(() => import('./pages/auth/signup')),
    privilege: [],
    exact: true,
  },
  {
    path: '/auth/forgotpassword',
    component: loadable(() => import('./pages/auth/forgotPassword')),
    privilege: [],
    exact: true,
  },

  // Service Map (dashboard) + its sub-pages
  {
    path: '/dashboard',
    component: loadable(() => import('./pages/dashboard')),
    privilege: ALL_FACILITY_ROLES,
    exact: true,
  },
  {
    path: '/dashboard/task-panel',
    component: loadable(() => import('./pages/dashboard/taskPanel')),
    privilege: ALL_FACILITY_ROLES,
    exact: true,
  },
  {
    path: '/dashboard/change/:booking_id/:trip_id',
    component: loadable(() => import('./pages/dashboard/change')),
    privilege: ALL_FACILITY_ROLES,
    exact: true,
  },
  {
    path: '/dashboard/bookings-view/:id',
    component: loadable(() => import('./pages/dashboard/viewBookingInfo')),
    privilege: ALL_FACILITY_ROLES,
    exact: true,
  },

  // Reservations (table + detail modal + /new)
  {
    path: '/rider-services/reservations',
    component: loadable(() => import('./pages/rider-services/reservations')),
    privilege: ALL_FACILITY_ROLES,
    exact: false,
  },

  // Account Management
  {
    path: '/account-management/users',
    component: loadable(() => import('./pages/account-management/users')),
    privilege: ALL_FACILITY_ROLES,
    exact: true,
  },
];

@connect(({ auth }) => ({ auth }))
class Router extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      startTime: Date.now(),
    };
  }

  componentDidUpdate(prevProps) {
    const logUserPageView = async (pageViewStartTime, pageViewEndTime) => {
      try {
        const { currentAccount } = await import(/* webpackChunkName: "auth-service" */ './services/auth');
        const user = await currentAccount();
        logPageView(user?.id, pageViewEndTime - pageViewStartTime);
      } catch (e) {
        if (e.message !== 'Not logged in.') {
          console.error(e);
        }
      }
    };

    if (this.props.location !== prevProps.location) {
      // Log the page view on route change
      const { startTime } = this.state;
      const endTime = Date.now();
      logUserPageView(startTime, endTime);
      this.setState({ startTime: endTime });
    }
  }

  generateRoute = (route) => {
    const { auth } = this.props;

    if (!auth.authorized || route.privilege.length === 0)
      return <Route path={route.path} component={route.component} key={route.path} exact={route.exact} />;

    for (let index = 0; index < route.privilege.length; index++) {
      const element = route.privilege[index];
      if (auth.is_admin && auth.is_admin.includes(element)) {
        return <Route path={route.path} component={route.component} key={route.path} exact={route.exact} />;
        break;
      }
    }
  };

  render() {
    const { history, auth } = this.props;

    return (
      <ConnectedRouter history={history}>
        <IndexLayout>
          <Switch>
            <Route exact path="/" key="/" render={() => <Redirect to="/dashboard" />} />
            {routes.map((route) => this.generateRoute(route))}

            {/* <Route path="/reports/map" component={ODMapPage}  /> */}
            {/* <Route path="/reports/history" component={HistoryDisplay} /> */}
            {/* <Route path="/reports/history/view/:id" component={bookingHistoryView} /> */}

            <Route component={NotFound} />
          </Switch>
        </IndexLayout>
      </ConnectedRouter>
    );
  }
}

export default withRouter(Router);
